import Button from 'components/_UI/Button'
import ImageUpload from 'components/_UI/ImageUpload'
import Text from 'components/_UI/Text'
import React, { useState } from 'react'
import { useEffect } from 'react'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import buttonText from 'texts/buttons/buttonText'
import colors from 'theme/colors'

export default function ImageProfile({ onToggleImage, onDeleteFile, allowedFiles, setErrorTypeImageProfile, errorTypeImageProfile,  setErrorImage, errorImage, isEdit, product}) {
    const [tryAgain, setTryAgain] = useState(false)

    useEffect(() => {
        
    }, [errorImage, errorTypeImageProfile])

    function toggleFile(files) {
        onToggleImage(files[0]);
    }
    
    return (
        <Container>
          
            <Text size='small' color={colors.primaryDashboard} marginTop={'10px'}  marginBottom='10px' type='bold'> Foto de perfil </Text>

            <ImageUpload 
                onToggleFile={toggleFile} 
                onDeleteFile={() => onDeleteFile()}
                tryAgain={tryAgain} 
                product={false}
                isEdit={isEdit}
                refreshTryAgain={() => {
                    setTryAgain(!tryAgain)
                    setErrorImage(false)
                }} 
            />

            <Column verticalCenter>
                <Text name='small' marginTop={'10px'}>Arquivos permitidos: {allowedFiles}.</Text>
                <Text name='small'>Tamanho máximo permitido: 2 MB</Text>
            </Column>


       
        {
            errorImage && (
                <Column marginTop='20px' verticalCenter>
                    <Text color={colors.danger} name='small'>Ocorreu um erro ao cadastrar a imagem</Text>
                    <Button 
                        category='outline'
                        onClick={() =>  {
                            setTryAgain(true)
                            setErrorImage(false)
                        }}
                    > 
                        {buttonText.tryAgain}
                    </Button>
                </Column>
            ) 
                
        }

        {errorTypeImageProfile && (
            <Column marginTop='10px' verticalCenter>
                <Text textAlign={'center'} name='small' color={colors.danger}>{errorTypeImageProfile}</Text>
                <Button 
                    category='outline'
                    onClick={() =>  {
                        setTryAgain(true)
                        setErrorImage(false)
                        setErrorTypeImageProfile(false)
                    }}
                > 
                    {buttonText.tryAgain}
                </Button>
            </Column>
        )}

        
        </Container>
    )
}

const Container = styled(Column)`
    margin-top: 40px;
    margin-bottom: 20px;
    align-items: center;

    & > div {
        justify-content: center;
    }
    & > div > div {
        border-radius: 50%;
        background: ${colors.neutralBackground};
    }

    & > span > div > div > p {
        display: none;
    }
`
